module.exports = {
      id: "envelope-usage",
      viewBox: "0 0 160 120",
      url: __webpack_public_path__ + "svg-sprite-1d11361007108583c67c4a96e18e035a.svg#envelope",
      toString: function () {
        return this.url;
      }
    }